var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIndividual(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.33333C5 7.30694 5.01027 7.24087 5.10881 7.15875C5.2095 7.07484 5.37992 7 5.6 7H26.4C26.6201 7 26.7905 7.07484 26.8912 7.15875C26.9897 7.24087 27 7.30694 27 7.33333V24.6667C27 24.6931 26.9897 24.7591 26.8912 24.8413C26.7905 24.9252 26.6201 25 26.4 25H5.6C5.37992 25 5.2095 24.9252 5.10881 24.8413C5.01027 24.7591 5 24.6931 5 24.6667V7.33333ZM5.6 5C4.34252 5 3 5.8817 3 7.33333V24.6667C3 26.1183 4.34252 27 5.6 27H26.4C27.6575 27 29 26.1183 29 24.6667V7.33333C29 5.8817 27.6575 5 26.4 5H5.6ZM19.2632 17.3073C20.2456 16.7263 20.2456 15.2737 19.2632 14.6927L14.2105 11.7045C13.2281 11.1235 12 11.8498 12 13.0118V18.9882C12 20.1502 13.2281 20.8765 14.2105 20.2955L19.2632 17.3073ZM14.1053 14.1324L17.2632 16L14.1053 17.8676V14.1324Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIndividual);
export default __webpack_public_path__ + "static/media/youtube-individual.690b3433.svg";
export { ForwardRef as ReactComponent };